import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { BANK_ACCOUNT_PARAM } from '../constants';
import { getPathWithToken, getSelectedBankAccountId } from '../utils';
/**
 * Builds a signing-flow path, carrying the customer's chosen bank account forward
 * so it survives navigation and a page reload.
 */
function useFlowPath(authorizationToken) {
    const { search } = useLocation();
    const bankAccountId = getSelectedBankAccountId(search);
    return useCallback((route, extraParams) => getPathWithToken(route, authorizationToken, {
        ...(bankAccountId
            ? { [BANK_ACCOUNT_PARAM]: String(bankAccountId) }
            : {}),
        ...extraParams,
    }), [authorizationToken, bankAccountId]);
}
export default useFlowPath;
